import { render, staticRenderFns } from "./loanGet.vue?vue&type=template&id=f505cf24&"
import script from "./loanGet.vue?vue&type=script&lang=js&"
export * from "./loanGet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports